'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dofOverlay = require('../dof-overlay');

var _dofOverlay2 = _interopRequireDefault(_dofOverlay);

var _dofImage = require('../dof-image');

var _dofImage2 = _interopRequireDefault(_dofImage);

var _icon = require('../setting/icon.base64');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var animation = weex.requireModule('animation');

var modal = weex.requireModule('modal');

exports.default = {
  components: { DofOverlay: _dofOverlay2.default, DofImage: _dofImage2.default },
  props: {
    height: {
      type: [String, Number],
      default: 800
    },
    width: {
      type: [String, Number],
      default: 540
    },
    top: {
      type: Number,
      default: 0
    },
    show: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    duration: {
      type: [String, Number],
      default: 300
    },
    hasOverlay: {
      type: Boolean,
      default: true
    },
    hasAnimation: {
      type: Boolean,
      default: true
    },
    timingFunction: {
      type: Array,
      default: function _default() {
        return ['ease-in', 'ease-out'];
      }
    },
    overlayCfg: {
      type: Object,
      default: function _default() {
        return {
          hasAnimation: true,
          timingFunction: ['cubic-bezier(0.25, 0.1, 0.25, 1.0)', 'cubic-bezier(0.25, 0.1, 0.25, 1.0)'],
          //timingFunction: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
          canAutoClose: false,
          duration: 300,
          opacity: 0.3
        };
      }
    },
    borderRadius: {
      type: [String, Number],
      default: 32
    },
    // overlayCanClose: {
    //   type: Boolean,
    //   default: true
    // },
    maskBgColor: {
      type: String,
      // default: '#ffffff'
      default: 'transparent'
    },
    opacity: {
      type: [Number, String],
      default: 0.3
    },
    screenWidth: {
      type: Number,
      default: 750
    }
  },
  data: function data() {
    return {
      localCloseIcon: '/assets/img/check/home_ic_closepop@3x.png',
      closeIcon: _icon2.default.closeIcon,
      maskTop: 264,
      opened: false
    };
  },
  computed: {
    mergeOverlayCfg: function mergeOverlayCfg() {
      return _extends({}, this.overlayCfg, {
        hasAnimation: this.hasAnimation
      });
    },
    maskStyle: function maskStyle() {
      var width = this.width,
          height = this.height,
          showClose = this.showClose,
          hasAnimation = this.hasAnimation,
          opened = this.opened,
          top = this.top,
          screenWidth = this.screenWidth;

      var newHeight = showClose ? height - 0 + 180 : height;
      var _weex$config$env = weex.config.env,
          deviceHeight = _weex$config$env.deviceHeight,
          deviceWidth = _weex$config$env.deviceWidth,
          platform = _weex$config$env.platform;

      var _deviceHeight = deviceHeight || 1334;
      var isWeb = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && platform.toLowerCase() === 'web';
      var navHeight = isWeb ? 0 : 130;
      var pageHeight = _deviceHeight / deviceWidth * screenWidth - navHeight;
      return {
        width: width + 'px',
        height: newHeight + 'px',
        left: (screenWidth - width) / 2 + 'px',
        top: (top || (pageHeight - height) / 2) + 'px',
        opacity: hasAnimation && !opened ? 0 : 1
      };
    },
    contentStyle: function contentStyle() {
      return {
        width: this.width + 'px',
        backgroundColor: this.maskBgColor,
        height: this.height + 'px',
        borderRadius: this.borderRadius + 'px',
        overflow: 'hidden'
      };
    },
    shouldShow: function shouldShow() {
      var _this = this;

      var show = this.show,
          hasAnimation = this.hasAnimation;

      hasAnimation && setTimeout(function () {
        _this.appearMask(show);
      }, 50);
      return show;
    }
  },
  methods: {
    // bottombar click to close
    closeIconClicked: function closeIconClicked() {
      console.log('closeIconClicked...');
      this.appearMask(false);
    },
    onImageLoad: function onImageLoad(event) {
      modal.toast({
        message: 'event:' + JSON.stringify(event)
      });
      if (event.success) {
        // Do something to hanlde success
      }
    },
    cancel: function cancel() {
      this.appearMask(false);
    },
    dofOverlayBodyClicked: function dofOverlayBodyClicked() {
      // console.log("mergeOverlayCfg",this.mergeOverlayCfg)
      console.log('this.overlayCfg.overlayCanClose', this.mergeOverlayCfg.canAutoClose);
      if (this.mergeOverlayCfg.canAutoClose) {
        this.show && this.appearMask(false);
      }
    },
    needEmit: function needEmit() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.opened = bool;
      !bool && this.$emit('dofMaskSetHidden', {});
    },
    appearMask: function appearMask(bool) {
      var _this2 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.duration;
      var hasAnimation = this.hasAnimation,
          timingFunction = this.timingFunction;

      var maskEl = this.$refs['dof-mask'];
      if (hasAnimation && maskEl) {
        animation.transition(maskEl, {
          styles: {
            opacity: bool ? 1 : 0
          },
          duration: duration,
          timingFunction: timingFunction[bool ? 0 : 1],
          delay: 0
        }, function () {
          _this2.needEmit(bool);
        });
      } else {
        this.needEmit(bool);
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-mask/index.vue
// module id = 353
// module chunks = 0 1